import {Component} from '@angular/core';
import {ModalRef} from 'src/app/ui-library/modal/modal-ref';

@Component({
    selector: 'app-required-assistance-services',
    templateUrl: './required-assistance-services.component.html',
    styleUrls: ['./required-assistance-services.component.css'],
    standalone: false
})
export class RequiredAssistanceServicesComponent {

    constructor(public modal: ModalRef) {
    }

    close(): void {
        this.modal.close();
    }

}
